import NewFireIcon from 'assets/svg/New_fireIcon'
import NewLightIcon from 'assets/svg/New_lightIcon'
import React from 'react'
import { DropdownType } from 'src/types'

interface NavbarData {
  name: string
  type: DropdownType
  dropdown: boolean
  linkIcon?: JSX.Element
}

const getHeaderNavbarData = (): NavbarData[] => {
  const navbarData = [
    {
      name: 'Buy Crypto',
      dropdown: true,
      type: 'buy crypto' as const,
    },
    {
      name: 'Futures',
      dropdown: true,
      type: 'futures' as const,
    },
    {
      name: 'Spot',
      dropdown: true,
      type: 'spot' as const,
    },
    {
      name: 'Explore Trading',
      dropdown: true,
      type: 'explore trading' as const,
    },
    {
      name: 'Copy Trading',
      linkIcon: <NewFireIcon red />,
      dropdown: true,
      type: 'copy trading' as const,
    },
    {
      name: 'Staking',
      dropdown: true,
      type: 'staking' as const,
    },
    {
      name: 'Price Alerts',
      linkIcon: <NewLightIcon />,
      dropdown: true,
      type: 'price alerts' as const,
    },
  ]

  return navbarData
}

export default getHeaderNavbarData
